























Currency = require 'models/currency.coffee'

module.exports =
  name: 'net_worth'
  components:
    transactions_table: require('components/inside/elements/transactions_table.vue').default
  metaInfo: -> { title: "#{@$t('Net Worth')} - #{@$t('Reports')}" }
  data: ->
    stats:
      start: {}
      end:   {}
      diff:  {}
    selected_day_transaction_ids: []
  computed:
    sample_data: -> @moneytotals.length <= 3
    selected_day_transactions: -> @$store.state.user.transactions.filter((tr) => this.selected_day_transaction_ids.includes(tr.id))
    moneytotals: ->
      # loop over days and calculate totals
      totals = []
      first_transaction = @$store.getters.transactions_entered[0] || { date: hm_date.constants.today }
      grouped_transactions = _.groupBy @$store.getters.transactions_entered, 'date'
      current_total = @$store.getters.all_accounts_sum
      prev_amount = 0
      date = hm_date.endOfMonth(new Date())
      while date > hm_date.startOfMonth(first_transaction.date)
        transactions_on_that_day = grouped_transactions[hm_date.format(date)] || []
        if transactions_on_that_day.length > 0
          amount = @$store.getters.transactions_sum(transactions_on_that_day)
          current_total -= prev_amount
          prev_amount = amount
          totals.push
            date: date.getTime(),
            transaction_ids: _.map(transactions_on_that_day, 'id'),
            amount: amount
            total: current_total
            formatted_total: Currency.format { value: current_total, currency: @$store.getters.default_currency }
        date = hm_date.addDays(date, -1)
      totals.reverse()

  watch:
    moneytotals: -> @$nextTick(@drawChart)
  mounted: -> @drawChart()
  methods:
    ###*
     * draw AMCharts chart with moneytotals
     * @return {nothing}
    ###
    drawChart: ->
      chart = @makeChart()
      @addChartZoomEvents(chart)
      #  Zoom to saved value in the past and current time
      chart.zoomToDates(
        new Date(Number(localStorage.getItem 'net_worth_start_date')),
        new Date()
      )
      ####### Clicking on chart
      chart.addListener 'changed', (e) => chart.lastCursorPosition = e.index
      chart.chartDiv.addEventListener 'click', =>
        return if not chart.lastCursorPosition
        mt = chart.dataProvider[ chart.lastCursorPosition ]
        @selected_day_transaction_ids = mt.transaction_ids
      #     guide = new AmCharts.Guide()
      #     guide.date = date
      #     guide.lineAlpha = 1
      #     guide.lineColor = "#c44"
      #     guide.label = text
      #     guide.position = "top"
      #     guide.inside = true
      #     guide.labelRotation = 90
      #     chart.categoryAxis.addGuide( guide )
      #     chart.validateData()
      ####### /Adding Guides to chart ############

    ###*
     * Make Chart object
     * @return {AMCharts chart}
    ###
    makeChart: ->
      if @moneytotals.every((mt) -> mt.total > 0)
        minimum = 0

      AmCharts.makeChart $(@$el).find('.chart')[0],
        pathToImages: '/amcharts-images/'
        language: 'ru'
        type: 'serial'
        theme: 'light'
        categoryField: 'date'
        dataProvider: @moneytotals
        autoMargins: false
        marginLeft: 45
        marginTop: 0
        marginRight: 0
        fontFamily: 'Inter'
        fontSize: 12
        showHandOnHover: true
        categoryAxis: { gridPosition: 'start', parseDates: true }
        graphs: [{
          id: 'g1'
          type: 'line'
          title: 'Всего денег'
          valueField: 'total'
          fillColors: '#57AE5B'
          fillAlphas: 0.7
          negativeLineColor: 'red'
          negativeFillColors: 'red'
          lineAlpha: 1
          lineThickness: 2
          lineColor: 'green'
          balloonFunction: (item, graph) =>
            # balloonText doesn't work properly in Safari
            "#{@$t('Total')}: #{item.dataContext.formatted_total}"
          animationPlayed: true
        }]
        valueAxes: [{ minimum: minimum, usePrefixes: true }],
        chartScrollbar:
          graph: 'g1'
          scrollbarHeight: 40
          gridAlpha: 0
          color: '#888888'
          backgroundAlpha: 0
          selectedBackgroundAlpha: 0.1
          selectedBackgroundColor: '#888888'
          graphFillAlpha: 0
          autoGridCount: true
          selectedGraphFillAlpha: 0
          graphLineAlpha: 0.2
          graphLineColor: 'green'
          selectedGraphLineColor: 'green'
          selectedGraphLineAlpha: 1
        legend: { enabled: false }
        chartCursor:
          categoryBalloonEnabled: true
          selectWithoutZooming: false
          selectionAlpha: 0.3
          bulletsEnabled: true
          zoomable: !HM.is_mobile

    ###*
     * @param {[AMCharts chart]}
     * @return {nothing}
    ###
    addChartZoomEvents: (chart) ->
      ###*
       * Calculate stats when zoom level changes
       * @param {integer} start_index
       * @param {integer} end_index
      ###
      setStats = (start_index, end_index) =>
        start_index ||= 0
        end_index ||= @moneytotals.length - 1
        start = @moneytotals[start_index]
        end   = @moneytotals[end_index]

        return unless start
        return unless end
        percentage = Math.round((end.total - start.total) / start.total * 100)
        if _.isFinite(percentage) and percentage > 0
          percentage = percentage + '%'
        else
          percentage = null

        @stats =
          start:
            formatted_date: hm_date.format(start.date, 'D MMMM YYYY')
            formatted_total: start.formatted_total
          end:
            formatted_date: hm_date.format(end.date, 'D MMMM YYYY')
            formatted_total: end.formatted_total
          diff:
            percentage: percentage

      debouncedZoomFn = (zoom_obj) =>
        setStats(zoom_obj.startIndex, zoom_obj.endIndex)
        localStorage.setItem 'net_worth_start_date', zoom_obj.startDate.getTime()

      chart.addListener 'zoomed', _.debounce(debouncedZoomFn, 300)

      setStats()
